import React from "react";
import styled from "styled-components";
const StyledTableHeader = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 10px 0 15px 0;
`;
const TableHeader = props => React.createElement(StyledTableHeader, Object.assign({}, props));
export default TableHeader;
